var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('Login'),_vm._v(" "),_c('PayInfo',[_c('div',{staticClass:"mod"},[_c('Tips')],1),_vm._v(" "),_c('QRCode'),_vm._v(" "),_c('BroadCast')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }